import { RefreshCw, Database, TrendingUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export function AdminDataRefresh() {
  const [loading, setLoading] = useState(false);

  const handleDataRefresh = async () => {
    setLoading(true);
    try {
      // Call the comprehensive refresh function to fix and populate data
      const { data, error } = await supabase.rpc('refresh_user_analytics' as any);
      
      if (error) {
        console.error('Data refresh error:', error);
        // Provide more specific error messages
        let errorMessage = 'Failed to refresh data';
        if (error.message?.includes('access_denied')) {
          errorMessage = 'Access denied: Only super admins can refresh analytics data';
        } else if (error.message?.includes('function')) {
          errorMessage = 'Database function error: Please check the system configuration';
        } else {
          errorMessage = `Data refresh failed: ${error.message}`;
        }
        toast.error(errorMessage);
      } else {
        const summary = data as any;
        if (summary && typeof summary === 'object') {
          toast.success(
            `Data refresh completed! Processed ${summary.users_processed || 0} users, ` +
            `created ${summary.activities_created || 0} activities, ${summary.logins_created || 0} login sessions, ` +
            `updated ${summary.features_updated || 0} feature records`
          );
        } else {
          toast.success('Data refresh completed successfully');
        }
      }
      
    } catch (error: any) {
      console.error('Data refresh error:', error);
      let errorMessage = 'Failed to refresh data';
      if (error.message?.includes('JWT')) {
        errorMessage = 'Authentication error: Please refresh your session and try again';
      } else if (error.message?.includes('network') || error.message?.includes('fetch')) {
        errorMessage = 'Network error: Please check your connection and try again';
      } else {
        errorMessage = error.message || 'An unexpected error occurred during data refresh';
      }
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Database className="h-5 w-5" />
          Data Management
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">
              Refresh analytics data and synchronize user statistics
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              Use this if user analytics appear outdated or incomplete
            </p>
          </div>
          <Button
            onClick={handleDataRefresh}
            disabled={loading}
            variant="outline"
            size="sm"
          >
            {loading ? (
              <>
                <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                Refreshing...
              </>
            ) : (
              <>
                <TrendingUp className="h-4 w-4 mr-2" />
                Refresh Data
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}